<!-- =========================================================================================
  File Name: SpeakerList.vue
  Description: Speaker List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style scoped>
.header-custome {
  padding-left: 2px;
}
</style>
<template>
  <div id="page-user-list" v-show="pageLoaded">
    <div class="header-custome">
      <h3>Speakers
          <span>{{
          gridSelectedRows ? "(Rows Selected: " + gridSelectedRows  + ")": ""
        }}</span>
      </h3>
      <div class="knowlg-base-wrap-sec">
        <span class="ml-3 text-default h3"
          >Total Speakers: {{ speakersData.length }}</span
        >
        <span class="ml-3 text-success h3"
          >Published: {{ speakerDataObj.published }}</span
        >
        <span class="ml-3 text-warning h3"
          >Hidden from View: {{ speakerDataObj.HideInList }}</span
        >
      </div>
    </div>
    <!-- <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Role</label>
          <v-select :options="roleOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="roleFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Status</label>
          <v-select :options="statusOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="statusFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Verified</label>
          <v-select :options="isVerifiedOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="isVerifiedFilter" class="mb-4 sm:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Department</label>
          <v-select :options="departmentOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="departmentFilter" />
        </div>
      </div>
    </vx-card>-->
    <div class="vx-card p-6 blank-attendee" v-show="speakersData.length < 1">
      <div class="entity-create-sec">
          <div class="emtity-icon">
            <!--<feather-icon class="" icon="UserCheckIcon" />-->
            <img src="../../assets/images/blank-page-images/speaker.png"/>
          </div>
          <div class="entity-create-desc">
            <h2>Create a Speaker</h2>
            <p>Adding Speakers brings more structure and makes the event more informative to the attendees. Once the speaker profile has been saved, it will automatically be displayed in the speaker section of the event page and inside the session details.</p>
            <div class="entity-setup-buttons">
              <vs-button color="primary" type="border" @click="getDefaultSettings">ADVANCED SETTINGS</vs-button>
              <vs-button color="primary" type="filled" class="new-entity-add-button " @click="$router.push('/event/speaker/add')">ADD NEW SPEAKER</vs-button>
              <vs-button
                color="primary"
                type="border"
                class="new-entity-add-button"
                @click="popupActive = true"
                >IMPORT SPEAKERS</vs-button
              >
            </div>
          </div>
      </div>
    </div>
    <div class="vx-card p-6" v-show="speakersData.length > 0">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ speakersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : speakersData.length }} of {{ speakersData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!--ADD Speaker-->
        <vx-tooltip text="Send mail to Speakers" position="bottom">
          <vs-button type="border mr-4" @click="getMailTpl"
            >Send Mail</vs-button
          >
        </vx-tooltip>
        
        <vs-button class="mr-4" color="rgb(76, 139, 246)" type="filled" v-on:click="addRecord ()">Create Speaker</vs-button>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="changeStatus(true)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Make Active</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item @click="changeStatus(false)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Make InActive</span>
              </span>
            </vs-dropdown-item>

            <!--
              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item>
            -->
          </vs-dropdown-menu>
        </vs-dropdown>
        <vs-button color="primary" type="border" class="ml-3" @click="popupActive=true">Import</vs-button>
        <vs-popup class="holamundo" title="Import Speaker" :active.sync="popupActive">
          <div class="import-attendee-wrapper">
            <div class="template-download">
              <h4>Download the template</h4>
              <a
                color="primary"
                type="filled"
                class="mt-3 btn"
                href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDownloads%2FTemplate_Speaker.xlsx?alt=media&token=af0ac634-c0d2-4034-baec-1e552285635f"
              >Download</a>
            </div>
            <!--
              <div class="add-content mt-5">
                <h4>Add content</h4>
                <p>Add content to the template. Please don’t delete or rename columns, leave them empty if unused.</p>
              </div>
            -->
            <div class="upload-file mt-5">
              <h4>Upload your file</h4>
              <div class="file-up-section">
                <p>Select XLSX file</p>
                <input
                  type="file"
                  id="speaker_file"
                  accept=".csv,.xlsx,.xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
                <vs-button color="rgb(76, 139, 246)" type="filled" class="sub-btn" v-on:click="UploadSpeaker">Upload</vs-button>
              </div>
            </div>
          </div>
        </vs-popup>
        <vs-button color="primary" type="border" class="ml-3 setting-btn" @click="getSettings">
          <img src="../../assets/images/settings.svg" alt="settings" />
        </vs-button>

      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="speakersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @selection-changed="onSelectionChanged"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>


    <vs-popup
          mailpopup
          class="holamundo customnewpopup"
          title="Mail Preview"
          :active.sync="popupActiveMail"
        >
              <div class="tab-text">
                <div class="vx-row" style="width: 622px">
                  <div class="vx-col md:w-1/1 w-full mt-4">
                    <h3>Subject: {{ welcomeMailSubject }}</h3>
                  </div>
                  <br />
                  <div v-html="welcomeMailText"></div>
                  <!--<quill-editor v-model="welcomeMailText"></quill-editor>-->
                  <br />
                  <div class="vx-col md:w-1/1 w-full mt-4">
                    <div click="sendbtn-section">
                      <vs-button
                        color="rgb(76, 139, 246)" type="filled"
                        @click="popupActiveMail = false"
                        >Cancel</vs-button
                      >
                      <vs-button
                        class="mail-btn"
                        color="rgb(76, 139, 246)" type="filled"
                        @click="sendMail"
                        >Send Mail</vs-button
                      >
                    </div>
                  </div>
                </div>
              </div>            
        </vs-popup>
    <div v-if="popupActive2 == true">
      <speaker-settings :data="popupActive2" :key="speakerSettingsResetKey" v-on:saveSpeakerSettingsData="saveSpeakerSettingsData"/>
    </div>

  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

// Store Module
import moduleSpeakerManagement from "@/store/speaker-management/moduleSpeakerManagement.js";
import bu from "@/store/bulkupload/BulkUpload.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import CellRendererHLActions from "./cell-renderer/CellRendererHLActions.vue";
import SpeakerSettings from "./SpeakerSetting.vue";
//console.log(db); 

export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    CellRendererHLActions,
    SpeakerSettings
  },
  data() {
    return {
      gridSelectedRows: 0,
      pageLoaded: false,
      settingsData: { ShowInAttendee: false },
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" }
      ],

      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" }
      ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" }
      ],

      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" }
      ],
      IsDefaultSettings: false,
      searchQuery: "",
      popupActive: false,
      popupActive2: false,
      speakerSettingsResetKey: 0,
      welcomeMailText: null,
      welcomeMailSubject: null,
      mailRecepients: [],
      sourcehtml: null,
      popupActiveMail: false,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: "",
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          width: 50,
          pinned: "left"
        },
        {
          headerName: "First Name",
          field: "FirstName",
          filter: true,
          //cellRendererFramework: "CellRendererLink",
          width: 200,
          //pinned: "left"
        },
        {
          headerName: "Last Name",
          field: "LastName",
          filter: true,
          //cellRendererFramework: "CellRendererLink",
          width: 200,
          //pinned: "left"
        },
        {
          headerName: "Email",
          field: "Email",
          filter: true,
          width: 200
        },
        {
          headerName: "Company",
          field: "Company",
          filter: true
        },
        {
          headerName: "Title",
          field: "Designation",
          filter: true
        },
        //{
        //  headerName: "Create Date",
        //  field: "CreateDate",
        //  filter: true
        //},
        /*{
          headerName: "Phone",
          field: "Phone",
          filter: true
        },*/
        /*{
          headerName: "Group",
          field: "Group",
          width: 150,
          filter: true
        },*/
        {
          headerName: "Actions",
          field: "transactions",
          cellRendererFramework: "CellRendererActions",
          width: 150,
          cellRendererParams: params => {
            return { id: params.data.SpeakerId };
          }
        },
        {
          headerName: "Status",
          field: "transactions",
          cellRendererFramework: "CellRendererStatus",
          width: 150,
          cellRendererParams: params => {
            return { id: params.data.SpeakerId };
          }
        },
        {
          headerName: "Hide from list",
          field: "transactions",
          cellRendererFramework: "CellRendererHLActions",
          width: 160,
          cellRendererParams: params => {
            return { id: params.data.SpeakerId };
          }
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
        CellRendererHLActions
      }
    };
  },
  watch: {
    roleFilter(obj) {
      this.setColumnFilter("role", obj.value);
    },
    statusFilter(obj) {
      this.setColumnFilter("status", obj.value);
    },
    isVerifiedFilter(obj) {
      const val =
        obj.value === "all" ? "all" : obj.value === "yes" ? "true" : "false";
      this.setColumnFilter("is_verified", val);
    },
    departmentFilter(obj) {
      this.setColumnFilter("department", obj.value);
    }
  },
  computed: {
    speakersData() {
      return this.$store.state.speakerManagement.speakers;
    },
    speakerDataObj(){
      let speakerDataObj = {
        published: 0,
        HideInList: 0
      }
      this.$store.state.speakerManagement.speakers.forEach(item=>{
        speakerDataObj.published += item.IsPublished ? 1 : 0;
        speakerDataObj.HideInList += item.HideInList ? 1 : 0;
      })
      return speakerDataObj;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    }
  },
  methods: {
    getDefaultSettings() {
      if(!this.settingsData.DefaultSettingsLoaded){
        this.IsDefaultSettings = true;
        this.settingsData = {
          ShowInAttendee: true,
          ShowSendMessageButton: true,
          ShowFilter: false,
          ShowMeetingButton: false,
          ShowSearch: false
        };
      }
      this.speakerSettingsResetKey += 1;
      this.popupActive2 = true;
    },
    getSettings() {
    this.speakerSettingsResetKey += 1;
    this.popupActive2 = true;
    },
    saveSettings() {
      this.$vs.loading();
      this.$store
        .dispatch("speakerManagement/saveSettings", {
          settingsData: this.settingsData,
          IsDefaultSettings: this.IsDefaultSettings
        })
        .then(res => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Settings",
            text: res.message
          });
          this.IsDefaultSettings = false;
          this.popupActive2 = false;
          this.$vs.loading.close();
        });
    },
    addRecord() {
      this.$router.push("/event/speaker/add").catch(() => {});
    },
    editRecord() {
      this.$router.push(`/speaker/edit/${268}`).catch(() => {});
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all"
      };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    GetDateTimeFromSeconds(seconds) {
      //var myObj = $.parseJSON('{"date_created":\""+seconds.toString()+"\"}');
      var myDate = new Date(1000 * seconds);
      //console.log(myDate.toString());
      //console.log(myDate.toLocaleDateString("en-IN"));
      return myDate.toUTCString();
      //return myDate.toLocaleString();
      //return myDate.toLocaleDateString("en-US");
    },
    UploadSpeaker: function() {
      var files = document.getElementById("speaker_file").files;
      bu.initVueComps(this.$vs)
      bu.StartUploadPrecss(files,'speaker');
    },
    changeStatus(Status) {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length) {
        this.$vs.loading();
        this.$store
          .dispatch("speakerManagement/changeStatus", {
            data: selectedRows,
            Status: Status
          })
          .then(res => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Status",
              text: res.message
            });
            this.gridApi.deselectAll();
            this.$vs.loading.close();
            this.$store.dispatch("speakerManagement/fetchSpeakers");
          })
          .catch(err => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          title: "Status",
          text: "Please Select a Row",
          //accept: this.deleteRecord,
          acceptText: "OK"
        });
      }
    },
    onSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();
      this.gridSelectedRows = selectedRows.length;
    },
    getMailTpl() {
      let selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length > 100) {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          //title: "Status",
          text: "Mail cannot be sent more than 100 attendee at a time!",
          acceptText: "OK",
        });
      } else {
        this.$vs.loading();
        this.welcomeMailText = "Loading...";
        this.$store
          .dispatch("speakerManagement/getMailTemplate")
          .then((res) => {
            this.welcomeMailText = res.html;
            this.welcomeMailSubject = res.subject;
            this.sourcehtml = res.sourcehtml;
            this.$vs.loading.close();
            this.popupActiveMail = true;
          });
      }
    },
    sendMail() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      //console.log(selectedRows);
      ///than you can map your selectedRows
      selectedRows.map((row) => {
        //console.log(row);
        this.mailRecepients.push(row.SpeakerId);
      });
      if (this.mailRecepients.length && this.welcomeMailSubject) {
        this.$vs.loading();
        this.$store
          .dispatch("speakerManagement/sendMail", {
            data: this.mailRecepients,
            subject: this.welcomeMailSubject,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              title: "Mail Sent",
              text: res.message,
            });
            this.mailRecepients = [];
            this.gridApi.deselectAll();
            this.$vs.loading.close();
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        //alert("Please Select Recepient!");
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Recepient",
          text: "Please Select Recepient! ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
      this.popupActiveMail = false;
    },
    saveSpeakerSettingsData(){
                this.settingsData = {
        DefaultSettingsLoaded: true
      };
    }
  },
  mounted() {
    this.gridOptions.api.showLoadingOverlay()
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    if (!moduleSpeakerManagement.isRegistered) {
      this.$store.registerModule("speakerManagement", moduleSpeakerManagement);
      moduleSpeakerManagement.isRegistered = true;
    }
    this.$vs.loading();
    this.$store.dispatch("speakerManagement/getSettings").then((res) => {
      this.settingsData = res;
      this.$store.dispatch("speakerManagement/fetchSpeakers").then((res) => {
        this.pageLoaded = true;
        this.$vs.loading.close();
      })
    })

  }
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>